import moment from 'moment';
import _ from 'lodash';
import {
    convertNumberToBRL,
    convertNumberToIntegerFormat,
    removeNonNumericCharacters
} from '@/utils';
import {
    USER_TYPE,
    QUOTATION_CLASSIFICATION,
    CONTACT_NETWORK_PROFILES,
    CONTACT_NETWORK_TYPE,
    CONTACT_SOURCE
} from '@/utils/constants';
export const currencyFilter = value => {
    if (!value) {
        return 'R$ 0,00';
    }
    value = parseFloat(value);
    return convertNumberToBRL(value);
};

export const numberFilter = value => {
    if (!value) {
        return '0';
    }
    value = parseInt(value);
    return convertNumberToIntegerFormat(value);
};

export const dateFilter = value => {
    if (!value) {
        return '';
    }
    value = value.toString();
    return moment(value).format('DD/MM/YYYY');
};

export const dateToDayMonth = value => {
    if (!value) {
        return '';
    }
    value = value.toString();
    moment.locale('pt-BR');
    return moment(value).format('DD MMM');
};

export const meetingExpirationDatetimeFilter = (value, meetingDelay) => {
    if (!value) {
        return '';
    }
    value = value.toString();
    meetingDelay = parseInt(meetingDelay);
    return moment(value)
        .add(meetingDelay, 'minutes')
        .format('DD/MM/YYYY HH:mm');
};

export const statusFilter = value => {
    if (!value) {
        return 'Status desconhecido';
    }

    switch (value) {
    case 'accepted':
        return 'Proposta enviada';
    case 'email-declined':
        return 'Participação rejeitada';
    case 'email-rejected':
        return 'Participação rejeitada';
    case 'feedback-sent':
        return 'Feedback enviado';
    case 'feedback-viewed':
        return 'Feedback visualizado';
    case 'lead-viewed':
        return 'Contato visualizado';
    case 'not visualized':
        return 'Detalhes da cotação não visualizado';
    case 'panel-credit-used':
        return 'Crédito do painel consumido';
    case 'payment-accepted':
        return 'Pagamento realizado';
    case 'payment-confirmed':
        return 'Pagamento confirmado';
    case 'payment-pending':
        return 'Pagamento pendente';
    case 'payment-test-viewed':
        return 'Pergunta de pagamento visualizada';
    case 'payment-viewed':
        return 'Tela de pagamento visualizada';
    case 'signup-completed':
        return 'Cadastro completo';
    case 'signup-viewed':
        return 'Cadastro visualizado';
    case 'visualized':
        return 'Detalhes da cotação visualizado';
    case 'panel-bonus-cash-used':
        return 'Bônus utilizado';
    case 'panel-engelink-cash-used':
        return 'Moedas utilizadas';
    default:
        return 'Status desconhecido';
    }
};

export const businessDateFilter = value => {
    if (!value) {
        return '';
    }
    value = value.toString();
    return moment.utc(value, 'YYYY-MM-DD').format('DD/MM/YYYY');
};

export const competitionObjectiveFilter = value => {
    if (!value) {
        return '';
    }

    switch (value) {
    case 1:
        return 'Serviço';
    case 2:
        return 'Equipamento';
    case 3:
        return 'Produto';
    case 4:
        return 'Condomínio';
    default:
        return '';
    }
};

export const contractorProfileFilter = value => {
    if (!value) {
        return 'Condomínio';
    }
    switch (value) {
    case USER_TYPE.CIVIL_CONSTRUCTION:
        return 'Construção civil';
    case USER_TYPE.CONDOMINUM:
        return 'Condomínio';
    case USER_TYPE.RENOVATION_AND_SERVICES:
        return 'Cliente Engelink';
    case USER_TYPE.CORPORATIVE:
        return 'Corporativo';
    case USER_TYPE.PROFESSIONAL_BUILDING_MANAGER:
        return 'Condomínio';
    case USER_TYPE.PRIVATE_PERSON:
        return 'Cliente Engelink';
    case USER_TYPE.SUPPLIER:
        return 'Fornecedor';
    case USER_TYPE.REQUESTER:
        return 'Condomínio';
    default:
        return 'Condomínio';
    }
};

export const timeFilter = value => {
    if (!value && !Number.isInteger(value)) {
        return '';
    }
    value = value.toString();
    return moment()
        .hours(0)
        .minutes(0)
        .seconds(value)
        .format('HH:mm:ss');
};

export const lowerCaseFilter = value => {
    if (!value) {
        return '';
    }
    return value.toLowerCase();
};

export const upperCaseFilter = value => {
    if (!value) {
        return '';
    }
    return value.toUpperCase();
};

export const classificationFilter = value => {
    switch (value) {
    case QUOTATION_CLASSIFICATION.LOW:
        return 'Baixa';
    case QUOTATION_CLASSIFICATION.MEDIUM:
        return 'Média';
    case QUOTATION_CLASSIFICATION.GOOD:
        return 'Boa';
    case QUOTATION_CLASSIFICATION.SPECIAL:
        return 'Especial';
    default:
        return value;
    }
};

export const networkContactFilter = value => {
    switch (value) {
    case CONTACT_NETWORK_PROFILES.BASIC:
        return 'Básico';
    // case CONTACT_NETWORK_PROFILES.COMPANY:
    //     return 'Empresa';
    case CONTACT_NETWORK_PROFILES.CORPORATIVE:
        return 'Pessoa jurídica';
    case CONTACT_NETWORK_PROFILES.CIVIL_CONSTRUCTION:
        return 'Construção civil';
    case CONTACT_NETWORK_PROFILES.PRIVATE_PERSON:
        return 'Cliente Engelink';
    case CONTACT_NETWORK_PROFILES.PROFESSIONAL_BUILDING_MANAGER:
        return 'Condomínio';
    case CONTACT_NETWORK_PROFILES.RENOVATION_AND_SERVICES:
        return 'Reformas e serviços';
    case CONTACT_NETWORK_PROFILES.SUPPLIER:
        return 'Fornecedor';
    case CONTACT_NETWORK_PROFILES.CONDOMINIUM:
        return 'Condomínio';
    case CONTACT_NETWORK_PROFILES.REQUESTER:
        return 'Condomínio';
    default:
        return value;
    }
};

export const planNetworkContactFilter = value => {
    switch (value) {
    case CONTACT_NETWORK_PROFILES.BASIC:
        return 'Básico';
    // case CONTACT_NETWORK_PROFILES.COMPANY:
    //     return 'Empresa';
    case CONTACT_NETWORK_PROFILES.CORPORATIVE:
        return 'Pessoa jurídica';
    case CONTACT_NETWORK_PROFILES.CIVIL_CONSTRUCTION:
        return 'Construção civil';
    case CONTACT_NETWORK_PROFILES.PRIVATE_PERSON:
        return 'Cliente Engelink';
    case CONTACT_NETWORK_PROFILES.PROFESSIONAL_BUILDING_MANAGER:
        return 'Síndico profissional';
    case CONTACT_NETWORK_PROFILES.RENOVATION_AND_SERVICES:
        return 'Reformas e serviços';
    case CONTACT_NETWORK_PROFILES.SUPPLIER:
        return 'Fornecedor';
    case CONTACT_NETWORK_PROFILES.CONDOMINIUM:
        return 'Condomínio';
    default:
        return value;
    }
};

export const numberWithPaddingZeros = value => {
    return ('00' + value).slice(-2);
};

export const monthYearFilter = value => {
    if (!value) {
        return '';
    }

    return moment(value).format('MM/YYYY');
};

export const capitalizeFilter = value => {
    if (!value) {
        return '';
    }

    return _.capitalize(value);
};

export const lowercaseFilter = value => {
    return value.toLowerCase();
};

export const shortSupplierName = name => {
    const fullName = name.split(' ');
    const firstName = fullName[0];
    const lastName = fullName[1] ? fullName[1] : '';
    const supplyName = fullName.length > 2 ? firstName + ' ' + lastName + '...' : firstName + ' ' + lastName;
    return supplyName;
};

export const cardTypeFilter = value => {
    switch (value) {
    case CONTACT_NETWORK_TYPE.PRO_CONTACT:
        return 'Contato Pro';
    case CONTACT_NETWORK_TYPE.QUALIFIED_CONTACT:
        return 'Contato Qualificado';
    default:
        return value;
    }
};

export const networkContactSourceFilter = value => {
    switch (value) {
    case CONTACT_SOURCE.CONTACT_NETWORK:
        return 'Leads Prediais';
    case CONTACT_SOURCE.PUBLIC_CONTACT:
        return 'Leads Prediais';
    case CONTACT_SOURCE.QUOTATION_SYSTEM:
        return 'Sistema de cotações';

    default:
        return value;
    }
};

export const snakeCaseFilter = value => {
    // return _.snakeCase(value);
    return value;
};

export const cnpjFilter = value => {
    if (!value) {
        return '';
    }

    value = removeNonNumericCharacters(value);
    return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
};


export const formatDateWithPipe = (originalDate, separator = '|') => {
    const currentDate = new Date(originalDate);
    const formattedDate = moment.utc(currentDate, 'YYYY-MM-DD').format('DD/MM/YYYY ' + separator + ' hh:mm');
    return formattedDate;
};